
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import OfficialDiscounts from "../pages/official-discounts/page";
import ShopPage from '../pages/shop/page';
import WeaponsShopPage from '../pages/shop/weapons/page';
import TacticalGearPage from '../pages/tactical-gear/page';
import EmploymentListPage from '../pages/employment-list/page';
import PlayerBlacklistsPage from '../pages/blacklists/player-blacklists/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/official-discounts",
    element: <OfficialDiscounts />,
  },
  {
    path: "/shop",
    element: <ShopPage />
  },
  {
    path: "/shop/weapons",
    element: <WeaponsShopPage />
  },
  {
    path: "/tactical-gear",
    element: <TacticalGearPage />
  },
  {
    path: "/employment-list",
    element: <EmploymentListPage />
  },
  {
    path: "/blacklists/player-blacklists",
    element: <PlayerBlacklistsPage />
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
